/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SendToRobotParameters { 
    /**
     * server name or IP address
     */
    server?: string;
    /**
     * communication port
     */
    port?: number;
    /**
     * login to server
     */
    user?: string;
    /**
     * password to login
     */
    pwd?: string;
    /**
     * Transfer mode for FTP connection
     */
    ftpTransferMode?: SendToRobotParameters.FtpTransferModeEnum;
    /**
     * Force the send to robot even though the robot might be in a state where it does not allow pattern change.
     */
    force?: boolean;
}
export namespace SendToRobotParameters {
    export type FtpTransferModeEnum = 'ACTIVE' | 'PASSIVE';
    export const FtpTransferModeEnum = {
        ACTIVE: 'ACTIVE' as FtpTransferModeEnum,
        PASSIVE: 'PASSIVE' as FtpTransferModeEnum
    };
}


